import type { SVGProps } from 'react';

export const Send = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="m18.725 12.85-13.95 5.875a.96.96 0 0 1-.875-.075.864.864 0 0 1-.4-.75V6.1c0-.317.133-.558.4-.725a.918.918 0 0 1 .875-.1l13.95 5.875c.367.167.55.45.55.85 0 .4-.183.683-.55.85ZM5 17l11.85-5L5 7v3.7l5.425 1.3L5 13.3V17Zm0 0V7v10Z" />
    </svg>
  );
};
